/* eslint-disable @next/next/no-img-element */
import * as S from './PoweredBy.styled'

const PoweredBy = () => {
  return (
    <S.PoweredBy>
      <img src='/imgs/powered-by-proptrack.png' alt='Powered by Proptrack' />
    </S.PoweredBy>
  )
}

export default PoweredBy
